import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { IconButtonWithTooltip } from "Components/Generic/IconButtonWithTooltip";
import { isCompany, isProject } from "Utils/IsType";
import { projectsContactRelevanceStart, projectsCompanyRelevanceStart, projectsRelevanceStart } from "Store/Actions";
import { WithTranslator } from "Components/Generic/Translator";
import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { IRelevanceActionButtonProps } from "./IRelevanceActionButtonProps";
import { useRelevanceActionButtonStyles } from "./UseRelevanceActionButtonStyles";

export const RelevanceActionButton = WithTranslator((props: IRelevanceActionButtonProps): JSX.Element => {
  const { item, translator } = props;
  const { preflightAuthentication } = useAuthenticationPreflight();
  const dispatch = useDispatch();
  const styles = useRelevanceActionButtonStyles();
  const isRelevant = item[`@isRelevant`];

  const onIsRelevantClick = useCallback(async () => {
    await preflightAuthentication();
    if (isProject(item)) {
      dispatch(projectsRelevanceStart([item[`@id`]]));
      return;
    }

    if (isCompany(item)) {
      dispatch(projectsCompanyRelevanceStart(item[`@id`]));
      return;
    }

    dispatch(projectsContactRelevanceStart(item[`@id`]));
  }, [item, dispatch, preflightAuthentication]);

  return (
    <IconButtonWithTooltip
      className={styles.button}
      iconProps={{ iconName: isRelevant ? `FavoriteStarFill` : `FavoriteStar` }}
      tooltip={
        isRelevant
          ? translator.get(`tooltip.setnotrelevant`, `Mark the record as irrelevant.`)
          : translator.get(`tooltip.setrelevant`, `Mark the record as relevant.`)
      }
      onClick={onIsRelevantClick}
    />
  );
});
